<template>

  <v-layout align-start>
    <v-flex>
      <v-form>
        <v-container grid-list-sm class="pa-4 white">
          <div>
            <v-row>
              <v-row>
                <v-col cols="6" sm="6" md="6" class="py-0">
                  <v-dialog ref="dialog1" v-model="modal1" :return-value.sync="fecha1" persistent width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="fecha1" :readonly="fecha1 == 1" label="Fecha de Inicio"
                        prepend-icon="event" v-bind="attrs" v-on="on" solo></v-text-field>
                    </template>
                    <v-date-picker v-model="fecha1" scrollable locale="es-es" :readonly="fecha1 == 1">
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="modal1 = false">Cancelar</v-btn>
                      <v-btn text color="primary" @click="$refs.dialog1.save(fecha1)">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>

                <v-col cols="6" sm="6" md="6" class="py-0">
                  <v-dialog ref="dialog" v-model="modal2" :return-value.sync="fecha2" persistent width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field v-model="fecha2" :readonly="fecha2 == 1" label="Fecha Fin" prepend-icon="event"
                        v-on="on" solo></v-text-field>
                    </template>
                    <v-date-picker v-model="fecha2" scrollable locale="es-es" :readonly="fecha2 == 1">
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="modal2 = false">Cancelar</v-btn>
                      <v-btn text color="primary" @click="$refs.dialog.save(fecha2)">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>
              </v-row>
              <v-col cols="12" md="12" class="py-0">
                <v-alert type="success" class="subtitle-2" color="primary">
                  <div class="d-flex align-rigth justify-space-between">
                     <v-btn icon small class="mx-1" @click="verdias(item)" title="Ver carpeta">
                        <v-icon>search</v-icon>
                      </v-btn>
                    <span>Expediente Digital</span>
                    <div class="d-flex">
                      <v-tooltip v-model="show" top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn icon v-bind="attrs" v-on="on" @click="guardardocumentofisico">
                            <v-icon>
                              assignment_add
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>Agregar Documento</span>
                      </v-tooltip>
                    </div>
                  </div>
                </v-alert>

              </v-col>

              <v-col cols="12" sm="3" md="3" class="py-0">
                <v-select v-model="empresaid" :items="empresaselect" label="Nombre de la Empresa"
                  v-on:change="selectempresanombre()" outlined></v-select>
              </v-col>
              <v-col cols="12" sm="3" md="3" class="py-0">
                <v-select v-model="tipodocumentoid" :items="tipodocumentoselect" label="Tipo de Documento"
                  outlined></v-select>
              </v-col>
              <v-col cols="12" sm="3" md="3" class="py-0">
                <v-select v-model="tipocomprobanteid" :items="tipocomprobanteselect" label="Tipo de Comprobante"
                  outlined></v-select>
              </v-col>
              <v-col cols="12" sm="3" md="3" class="py-0">
                <v-row no-gutters> <v-col cols="12" sm="9"> <v-text-field v-model="carpetadocumentonombre"
                      label="Nombre Completo del Documento o Carpeta" outlined></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="3" class="d-flex align-center pl-2">
                    <v-btn color="primary" fab dark @click="guardarcarpetaodocumento">
                      <v-icon>mdi-content-save</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>

            </v-row>

            <template>
              <v-treeview v-model="tree" :items="carpetas" activatable item-key="carpetaid" :open.sync="openedFolders"
                open-on-click>
                <template v-slot:prepend="{ item, open, leaf }">
                  <v-icon v-if="item.file === 1" @click.stop="toggleFolder(item)">
        {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
      </v-icon>
      <v-icon v-else-if="item.file === 2">
        mdi-file-pdf-box
      </v-icon>
                </template>

                <!-- Aplicamos clase al contenedor completo del label -->
                <template v-slot:label="{ item }">
                  <div class="tree-node" :class="{ 'selected-node': carpetaid === item.carpetaid }"
                    @click.stop="handleNodeClick(item)">
                    {{ item.carpetanombre }}
                  </div>
                </template>

                <template v-slot:append="{ item }">
                  <div @click.stop="">
                    <template v-if="item.file === 1">
                      <v-btn icon small class="mx-1" @click="ver(item)" title="Ver carpeta">
                        <v-icon>visibility</v-icon>
                      </v-btn>
                      <v-btn icon small class="mx-1" @click="editItem(item)" title="Modificar carpeta">
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                      <v-btn icon small class="mx-1" @click="deleteItem(item)" title="Eliminar carpeta">
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </template>
                    <template v-else>
                      <v-btn icon small class="mx-1" @click="editFile(item)" title="Modificar archivo">
                        <v-icon>mdi-file-document-edit</v-icon>
                      </v-btn>
                      <v-btn icon small class="mx-1" @click="deleteFile(item)" title="Eliminar archivo">
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </template>
                  </div>
                </template>
              </v-treeview>
            </template>




          </div>
        </v-container>
      </v-form>

      <template>
        <v-dialog v-model="modaldocumento" max-width="1200" :hide-overlay="$vuetify.breakpoint.xsOnly"
          transition="dialog-bottom-transition">
          <v-card>
            <v-alert shaped dark color="primary">
              Datos de Documento
            </v-alert>

            <v-card-text>
              <v-container fluid class="pa-0" style="max-width: 1000px;"> <v-row justify="center">


                  <v-form v-if="tipocomprobanteid == 1" style="width: 100%;">
                    <v-container fluid grid-list-sm class="pa-4 white">
                      <v-row>
                        <v-col cols="12" md="12">
                          <v-alert type="success" class="subtitle-2 text-center" color="primary">
                            ALTA DE DOCUMENTOS: {{ fullPath }} / {{ carpetanombre }}
                          </v-alert>
                        </v-col>
                        <v-col cols="12" md="12">
                          <div align="center" justify="center">
                            <div class="my-2">
                              <v-btn color="primary" @click="triggerFileInput">Cargar XML</v-btn>
                            </div>
                            <input type="file" ref="fileInput" @change="handleFileChange" accept=".xml"
                              style="display: none;">
                          </div>
                        </v-col>

                        <v-col cols="12" sm="4" md="4" class="py-0">
                          <v-select v-model="empresaid" :items="empresaselect" label="Nombre de la Empresa"
                            v-on:change="selectempresanombre()" outlined></v-select>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="py-0">
                          <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40"
                            transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field v-model="documentofechacarga" label="Fecha del Flete" prepend-icon="event"
                                readonly v-bind="attrs" v-on="on" outlined></v-text-field>
                            </template>
                            <v-date-picker v-model="documentofechacarga" @input="menu = false"></v-date-picker>
                          </v-menu>
                        </v-col>

                        <v-col cols="12" sm="4" md="4" class="py-0">
                          <v-text-field v-model="documentofolio" label="Folio Factura" required outlined></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="4" md="4" class="py-0">
                          <v-text-field v-model="documentocombustible" label="Combustible" required
                            outlined></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="4" md="4" class="py-0">
                          <v-text-field v-model="documentolitros" label="Litros" required outlined></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="4" md="4" class="py-0">
                          <v-text-field v-model="documentoprecio" label="Precio" required outlined></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="4" md="4" class="py-0">
                          <v-text-field v-model="documentosubtotal" label="Sub Total" required outlined></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="4" md="4" class="py-0">
                          <v-text-field v-model="documentoiva" label="Iva" required outlined></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="4" md="4" class="py-0">
                          <v-text-field v-model="documentototal" label="Total" required outlined></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="12" md="12" class="py-0">
                          <v-text-field v-model="documentouiid" label="UUID Sat" required outlined></v-text-field>
                        </v-col>

                        <v-col cols="12" md="12">
                          <v-textarea v-model="documentoobservacion" outlined name="input-7-7"
                            label="Observacion del Documento" :readonly="vsdocumentoobservacion == 1"></v-textarea>
                        </v-col>
                      </v-row>

                      <template>
                        <div>
                          <v-col cols="12" md="12" align="center" justify="center">
                            <label>
                              Carga El Documento
                              <input type="file" id="file" ref="file" accept="image/jpeg, image/png, .pdf"
                                v-on:change="handleFileUpload()" />
                            </label>
                          </v-col>
                          <div align="center" justify="center">
                            <div class="my-2">
                              <v-btn color="secondary" @click="close">Cancelar</v-btn>
                              <v-btn color="primary" @click="guardardocumento">Guardar</v-btn>
                            </div>
                          </div>

                          <v-card max-width="1200" class="mx-auto">
                            <v-list-item>
                              <v-list-item-avatar color="grey"></v-list-item-avatar>
                              <v-list-item-content align="center" justify="center">
                                <v-list-item-title class="headline">Visualizando el Documento</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>

                            <v-col cols="12" md="12" align="center" justify="center" v-if="imagenopdf == 1">
                              <v-img :src="imagePreview"></v-img>
                            </v-col>

                            <v-col cols="12" md="12" v-if="imagenopdf == 2">
                              <iframe :src="pdfPreview" width="100%" style="height: 80vh;"
                                class="embed-responsive-item"></iframe>
                            </v-col>

                            <v-card-text align="center" justify="center">Antes de Guardar el Documento Verifique que sea
                              el
                              Correcto</v-card-text>
                          </v-card>
                        </div>
                      </template>
                    </v-container>
                  </v-form>

                  <v-form v-if="tipocomprobanteid == 2" style="width: 100%;">
                    <v-container fluid grid-list-sm class="pa-4 white">
                      <v-row>
                        <v-col cols="12" md="12">
                          <v-alert type="success" class="subtitle-2 text-center" color="primary">
                            ALTA DE DOCUMENTOS: {{ fullPath }} / {{ carpetanombre }}
                          </v-alert>
                        </v-col>

                        <v-col cols="12" sm="6" md="6" class="py-0">
                          <v-select v-model="empresaid" :items="empresaselect" label="Nombre de la Empresa"
                            v-on:change="selectempresanombre()" outlined></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" class="py-0">
                          <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40"
                            transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field v-model="documentofechacarga" label="Fecha de la Carta Porte"
                                prepend-icon="event" readonly v-bind="attrs" v-on="on" outlined></v-text-field>
                            </template>
                            <v-date-picker v-model="documentofechacarga" @input="menu = false"></v-date-picker>
                          </v-menu>
                        </v-col>

                        <v-col cols="12" sm="4" md="4" class="py-0">
                          <v-text-field v-model="documentofolio" label="Folio Factura" required outlined></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="4" md="4" class="py-0">
                          <v-text-field v-model="documentocartaporte" label="Folio Carta Porte" required
                            outlined></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="4" md="4" class="py-0">
                          <v-select v-model="combustiblecargaid" :items="combustiblecargaselect"
                            label="Tipo de Combustible" outlined v-on:change="selectecombustiblenombre()"></v-select>
                        </v-col>

                        <v-col cols="12" md="12">
                          <v-textarea v-model="documentoobservacion" outlined name="input-7-7"
                            label="Observacion del Documento" :readonly="vsdocumentoobservacion == 1"></v-textarea>
                        </v-col>
                      </v-row>

                      <template>
                        <div>
                          <v-col cols="12" md="12" align="center" justify="center">
                            <label>
                              Carga El Documento
                              <input type="file" id="file" ref="file" accept="image/jpeg, image/png, .pdf"
                                v-on:change="handleFileUpload()" />
                            </label>
                          </v-col>
                          <div align="center" justify="center">
                            <div class="my-2">
                              <v-btn color="secondary" @click="close">Cancelar</v-btn>
                              <v-btn color="primary" @click="guardardocumento">Guardar</v-btn>
                            </div>
                          </div>

                          <v-card max-width="1200" class="mx-auto">
                            <v-list-item>
                              <v-list-item-avatar color="grey"></v-list-item-avatar>
                              <v-list-item-content align="center" justify="center">
                                <v-list-item-title class="headline">Visualizando el Documento</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>

                            <v-col cols="12" md="12" align="center" justify="center" v-if="imagenopdf == 1">
                              <v-img :src="imagePreview"></v-img>
                            </v-col>

                            <v-col cols="12" md="12" v-if="imagenopdf == 2">
                              <iframe :src="pdfPreview" width="100%" style="height: 80vh;"
                                class="embed-responsive-item"></iframe>
                            </v-col>

                            <v-card-text align="center" justify="center">Antes de Guardar el Documento Verifique que sea
                              el
                              Correcto</v-card-text>
                          </v-card>
                        </div>
                      </template>
                    </v-container>
                  </v-form>

                  <v-form v-if="tipocomprobanteid == 3" style="width: 100%;">
                    <v-container fluid grid-list-sm class="pa-4 white">
                      <v-row>
                        <v-col cols="12" md="12">
                          <v-alert type="success" class="subtitle-2 text-center" color="primary">
                            ALTA DE DOCUMENTOS: {{ fullPath }} / {{ carpetanombre }}
                          </v-alert>
                        </v-col>

                        <v-col cols="12" sm="3" md="3" class="py-0">
                          <v-select v-model="empresaid" :items="empresaselect" label="Nombre de la Empresa"
                            v-on:change="selectempresanombre()" outlined></v-select>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" class="py-0">
                          <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40"
                            transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field v-model="documentofechacarga" label="Fecha de la Carta Porte"
                                prepend-icon="event" readonly v-bind="attrs" v-on="on" outlined></v-text-field>
                            </template>
                            <v-date-picker v-model="documentofechacarga" @input="menu = false"></v-date-picker>
                          </v-menu>
                        </v-col>

                        <v-col cols="12" sm="3" md="3" class="py-0">
                          <v-text-field v-model="documentofolio" label="Folio Factura" required outlined></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="3" md="3" class="py-0">
                          <v-select v-model="combustiblecargaid" :items="combustiblecargaselect"
                            label="Tipo de Combustible" outlined v-on:change="selectecombustiblenombre()"></v-select>
                        </v-col>

                        <v-col cols="12" md="12">
                          <v-textarea v-model="documentoobservacion" outlined name="input-7-7"
                            label="Observacion del Documento" :readonly="vsdocumentoobservacion == 1"></v-textarea>
                        </v-col>
                      </v-row>

                      <template>
                        <div>
                          <v-col cols="12" md="12" align="center" justify="center">
                            <label>
                              Carga El Documento
                              <input type="file" id="file" ref="file" accept="image/jpeg, image/png, .pdf"
                                v-on:change="handleFileUpload()" />
                            </label>
                          </v-col>
                          <div align="center" justify="center">
                            <div class="my-2">
                              <v-btn color="secondary" @click="close">Cancelar</v-btn>
                              <v-btn color="primary" @click="guardardocumento">Guardar</v-btn>
                            </div>
                          </div>

                          <v-card max-width="1200" class="mx-auto">
                            <v-list-item>
                              <v-list-item-avatar color="grey"></v-list-item-avatar>
                              <v-list-item-content align="center" justify="center">
                                <v-list-item-title class="headline">Visualizando el Documento</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>

                            <v-col cols="12" md="12" align="center" justify="center" v-if="imagenopdf == 1">
                              <v-img :src="imagePreview"></v-img>
                            </v-col>

                            <v-col cols="12" md="12" v-if="imagenopdf == 2">
                              <iframe :src="pdfPreview" width="100%" style="height: 80vh;"
                                class="embed-responsive-item"></iframe>
                            </v-col>

                            <v-card-text align="center" justify="center">Antes de Guardar el Documento Verifique que sea
                              el
                              Correcto</v-card-text>
                          </v-card>
                        </div>
                      </template>
                    </v-container>
                  </v-form>

                  <v-form v-if="tipocomprobanteid == 4" style="width: 100%;">
                    <v-container fluid grid-list-sm class="pa-4 white">
                      <v-row>
                        <v-col cols="12" md="12">
                          <v-alert type="success" class="subtitle-2 text-center" color="primary">
                            ALTA DE DOCUMENTOS: {{ fullPath }} / {{ carpetanombre }}
                          </v-alert>
                        </v-col>

                        <v-col cols="12" sm="6" md="6" class="py-0">
                          <v-select v-model="empresaid" :items="empresaselect" label="Nombre de la Empresa"
                            v-on:change="selectempresanombre()" outlined></v-select>
                        </v-col>

                        <v-col cols="12" sm="6" md="6" class="py-0">
                          <v-text-field v-model="documentofolio" label="Folio Factura" required outlined></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6" md="6" class="py-0">
                          <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40"
                            transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field v-model="documentofechacarga" label="Fecha de Recepcion"
                                prepend-icon="event" readonly v-bind="attrs" v-on="on" outlined></v-text-field>
                            </template>
                            <v-date-picker v-model="documentofechacarga" @input="menu = false"></v-date-picker>
                          </v-menu>
                        </v-col>

                        <v-col cols="12" sm="6" md="6" class="py-0">
                          <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40"
                            transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field v-model="documentofechavence" label="Fecha del Vencimiento"
                                prepend-icon="event" readonly v-bind="attrs" v-on="on" outlined></v-text-field>
                            </template>
                            <v-date-picker v-model="documentofechavence" @input="menu1 = false"></v-date-picker>
                          </v-menu>
                        </v-col>

                        <v-col cols="12" md="12">
                          <v-textarea v-model="documentoobservacion" outlined name="input-7-7"
                            label="Observacion del Documento" :readonly="vsdocumentoobservacion == 1"></v-textarea>
                        </v-col>
                      </v-row>

                      <template>
                        <div>
                          <v-col cols="12" md="12" align="center" justify="center">
                            <label>
                              Carga El Documento
                              <input type="file" id="file" ref="file" accept="image/jpeg, image/png, .pdf"
                                v-on:change="handleFileUpload()" />
                            </label>
                          </v-col>
                          <div align="center" justify="center">
                            <div class="my-2">
                              <v-btn color="secondary" @click="close">Cancelar</v-btn>
                              <v-btn color="primary" @click="guardardocumento">Guardar</v-btn>
                            </div>
                          </div>

                          <v-card max-width="1200" class="mx-auto">
                            <v-list-item>
                              <v-list-item-avatar color="grey"></v-list-item-avatar>
                              <v-list-item-content align="center" justify="center">
                                <v-list-item-title class="headline">Visualizando el Documento</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>

                            <v-col cols="12" md="12" align="center" justify="center" v-if="imagenopdf == 1">
                              <v-img :src="imagePreview"></v-img>
                            </v-col>

                            <v-col cols="12" md="12" v-if="imagenopdf == 2">
                              <iframe :src="pdfPreview" width="100%" style="height: 80vh;"
                                class="embed-responsive-item"></iframe>
                            </v-col>

                            <v-card-text align="center" justify="center">Antes de Guardar el Documento Verifique que sea
                              el
                              Correcto</v-card-text>
                          </v-card>
                        </div>
                      </template>
                    </v-container>
                  </v-form>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions class="mt-n10 mx-auto">
              <div class="flex-grow-1"></div>
              <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>

      <template>
        <v-dialog v-model="verdialog" fullscreen hide-overlay transition="dialog-bottom-transition">

          <v-card>
            <v-toolbar dark color="primary">
              <v-btn icon dark @click="verdialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>{{ carpetanombre }}</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <template>
              <v-container>
                <v-row>
                  <v-col v-for="(card1, documentoid) in documentosporfecha" :key="documentoid" cols="12" sm="6" md="4"
                    lg="3">
                    <v-card class="mx-auto" max-width="344" outlined>
                      <v-list-item three-line>
                        <v-list-item-content>
                          <div class="text-overline mb-4">
                            {{ card1.documentofecha }}
                          </div>
                          <div class="text-overline mb-4">
                            Folio:{{ card1.documentofolio }}
                          </div>
                          <v-list-item-title class="text-h5 mb-1">
                            {{ card1.documentohora }}
                          </v-list-item-title>
                          <template>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-list-item-subtitle v-bind="attrs" v-on="on" class="text-truncate">
                                  {{ card1.documentonombre }}
                                </v-list-item-subtitle>
                                <v-list-item-subtitle v-bind="attrs" v-on="on" class="text-truncate"
                                  v-if="card1.documentotipo == 1">
                                  Factura
                                </v-list-item-subtitle>
                                <v-list-item-subtitle v-bind="attrs" v-on="on" class="text-truncate"
                                  v-if="card1.documentotipo == 2">
                                  Carta Porte
                                </v-list-item-subtitle>
                                <v-list-item-subtitle v-bind="attrs" v-on="on" class="text-truncate"
                                  v-if="card1.documentotipo == 3">
                                  Veeder-Root
                                </v-list-item-subtitle>
                                <v-list-item-subtitle v-bind="attrs" v-on="on" class="text-truncate"
                                  v-if="card1.documentotipo == 4">
                                  Documento
                                </v-list-item-subtitle>
                              </template>
                              <span>{{ card1.documentonombre }}</span>
                            </v-tooltip>
                          </template>
                        </v-list-item-content>

                        <v-list-item-avatar tile size="80">
                          <v-icon v-if="card1.documentoextencion == 2" size="60" color="black">fa-solid
                            fa-file-pdf</v-icon>
                          <v-icon v-else-if="card1.documentoextencion == 1" size="60" color="black">fa-solid
                            fa-camera</v-icon>
                          <v-icon v-else size="60" color="white">mdi-file-pdf</v-icon>
                        </v-list-item-avatar>
                      </v-list-item>


                      <v-card-actions>
                        <v-btn outlined rounded text @click="openDocument(card1)">
                          Ver
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </template>




          </v-card>





        </v-dialog>


      </template>





    </v-flex>
  </v-layout>

</template>

<script>
import axios from "axios";
import { Alert } from "bootstrap";
import moment from "moment"; // Asumiendo que usas moment en alguna otra parte de tu proyecto

export default {
  data: () => ({
    initiallyOpen: [], // Considera establecer esto según los datos de la API o dejarlo vacío

    tree: [],
    carpetas: [], // Aquí se almacenarán los datos de tu API
    carpetanombre: "", // v-model para tu campo de texto
    carpetaid: 0,
    expedientenombre: "",
    empresaid: 1,
    empresaselect: [],
    tipodocumentoid: 1,
    tipodocumentoselect: [
      { text: "CARPETA", value: 1 },
      { text: "DOCUMENTO", value: 2 }
    ],
    tipocomprobanteid: 0,
    tipocomprobanteselect: [
      { text: "NO APLICA", value: 0 },
      { text: "FACTURA", value: 1 },
      { text: "CARTA PORTE", value: 2 },
      { text: "VEEDER-ROOT", value: 3 },
      { text: "DOCUMENTO", value: 4 }
    ],
    carpetadocumentonombre: "",
    carpetaodocumento: "",
    modaldocumento: 0,
    fullPath: "",
    imagenopdf: 0,
    guardarvisible: 0,
    documentoobservacion: "",
    vsdocumentoobservacion: "",
    documentocombustible: "",
    documentofolio: "",
    //documentofechacarga: "",
    documentofechacarga: moment(new Date(), "DD/MM/YYYY").format("YYYY-MM-DD"),
    documentofechavence: moment(new Date(), "DD/MM/YYYY").format("YYYY-MM-DD"),

    documentototal: "",
    documentolitros: "",
    menu: false,
    show: false,
    menu1: false,
    show1: false,
    documentoiva: "",
    documentosubtotal: "",
    documentoprecio: "",
    combustibleid: "",
    documentocartaporte: "",
    documentouiid: "",
    combustiblecargaid: "",
    combustiblecargaselect: [],
    verdialog: 0,
    fecha1: moment(new Date(), "DD/MM/YYYY").format("YYYY-MM-DD"),
    fecha2: moment(new Date(), "DD/MM/YYYY").format("YYYY-MM-DD"),
    modal1: false,
    modal2: false,
    documentosporfecha: [],
    rutacompleta: "",
    openedFolders: [],
    cards: [],
    file:null,


  }),

  created() {
    //this.listar();
    this.listar1();
    this.selectempresa();
    this.selectgasolinatipo();
  },

  methods: {
    handleNodeClick(item) {
      this.carpetaid = item.carpetaid; // Correcto: usas item.id para la carpeta seleccionada
      this.carpetaodocumento = item.carpetaodocumento;
      this.fullPath = this.getFolderPath(item); // Aquí calculas la ruta completa
      this.carpetanombre = item.carpetanombre;
      this.documentonombre = item.carpetanombre;
      this.tipocomprobanteid = item.tipodedocumento;
      this.tipodocumentoid = item.carpetaodocumento;
      this.carpetadocumentonombre = item.carpetanombre;

      this.rutacompleta = this.fullPath + "/" + item.carpetanombre;

      this.$swal.fire({
        title: item.carpetanombre,
        html: "Direccion: " + this.fullPath,
        timer: 2000,
        timerProgressBar: true,
        didOpen: () => {
          Swal.showLoading();
          const timer = Swal.getPopup().querySelector("b");
          timerInterval = setInterval(() => {
            timer.textContent = `${Swal.getTimerLeft()}`;
          }, 100);
        },
        willClose: () => {
          clearInterval(timerInterval);
        }
      }).then((result) => {

      });

      // La siguiente línea no es necesaria aquí si ya usas item.id
      // this.carpetaid=item.carpetaid
    },

    getFolderPath(item) {
      let path = [item.carpetanombre];
      let currentItem = item;
      console.log('Iniciando getFolderPath para:', item.carpetanombre, 'ID:', item.carpetaid);

      // La condición es correcta si 0 es el ID de la raíz
      while (currentItem.carpetapadre !== null && currentItem.carpetapadre !== 0 && currentItem.carpetapadre !== 0) {
        console.log('Buscando padre para currentItem:', currentItem.carpetanombre, 'con carpetapadre:', currentItem.carpetapadre);
        const parent = this.findItemById(this.carpetas, currentItem.carpetapadre);
        if (parent) {
          path.unshift(parent.carpetanombre); // Agrega el nombre del padre al principio de la ruta
          currentItem = parent;
          console.log('Padre encontrado. Path actual:', path.join('/'));

        } else {
          console.log('Padre no encontrado o fin de la cadena. ID buscado:', currentItem.carpetapadre);
          break; // Detener si el padre no se encuentra
        }
      }
      path.pop(item.carpetanombre);
      console.log('Ruta final:', path.join(''));
      return path.join('/');
    },

    findItemById(items, id) {
      console.log('Buscando ID:', id, 'en items:', items.map(i => i.carpetapadre + ' (' + i.carpetanombre + ')'));
      for (const item of items) {
        // Importante: Asegurarse de que los tipos de id coincidan (número vs string)
        if (String(item.carpetaid) === String(id)) { // Usar String() para asegurar la comparación de tipo

          console.log(item.id);
          console.log('Encontrado:', item.carpetanombre);
          return item;
        }
        if (item.children && item.children.length > 0) {
          const found = this.findItemById(item.children, id);
          if (found) {
            return found;
          }
        }
      }
      console.log('No encontrado para ID:', id);
      return null;
    },

    ver() {
      this.verdialog = 1;
      this.documentosporfecha = [];
      this.listarporfecha();

    },

    verdias() {
      this.verdialog = 1;
      this.documentosporfecha = [];
      this.listarporfechatodos();

    },

    // Select
    selectempresa() {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/empresas/listar", configuracion)
        .then(function (response) {
          listaArray = response.data.empresa;
          listaArray.map(function (x) {
            me.empresaselect.push({
              text: x.empresanombre,
              value: x.empresaid
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    toggleFolder(item) {
      // Este método se llama cuando se hace clic en el icono de la carpeta/flecha.
      // Si la carpeta ya está abierta, la cerramos (la quitamos de openedFolders).
      // Si está cerrada, la abrimos (la agregamos a openedFolders).
      const index = this.openedFolders.indexOf(item.carpetaid);
      if (index > -1) {
        // La carpeta está abierta, la cerramos
        this.openedFolders.splice(index, 1);
      } else {
        // La carpeta está cerrada, la abrimos
        this.openedFolders.push(item.carpetaid);
      }
    },

    openDocument(item) {
      let me = this;
      let header = { Authorization: this.$store.state.token };
      // ¡IMPORTANTE! Agrega responseType: 'blob' aquí
      let configuracion = {
        headers: header,
        responseType: 'blob' // Esto le dice a Axios que espere una respuesta binaria
      };

      axios
        .post("api/documentos/verdocumentotodos", {
          documentoid: item.documentoid
        }, configuracion)
        .then(function (response) {
          // La respuesta es un objeto Blob
          const fileBlob = response.data;
          // El tipo de contenido viene en los headers de la respuesta
          const contentType = response.headers['content-type'];

          // Crea un URL de objeto para el Blob. Esto es un URL temporal que el navegador puede usar.
          const blobUrl = URL.createObjectURL(fileBlob);

          // Opción 1: Abrir el documento en una nueva pestaña
          // Esta es la opción más sencilla y robusta para PDFs e imágenes.
          window.open(blobUrl, '_blank');

        })
        .catch(function (error) {
          console.error("Error al obtener el documento:", error);
          // Manejo de errores específicos del backend cuando el archivo no existe
          if (error.response && error.response.data && typeof error.response.data.code !== 'undefined') {
            // Si el backend devuelve JSON de error (cuando el archivo no existe)
            const errorData = JSON.parse(new TextDecoder().decode(error.response.data)); // Decodifica el Blob de error a JSON
            if (errorData.code == 400) {
              me.$swal("La Sesión ha Expirado o el documento no se encontró: " + errorData.message);
              me.$store.dispatch("salir");
            } else {
              me.$swal("Error del servidor: " + errorData.message);
            }
          } else if (error.response) {
            // Otros errores HTTP (ej. 500 del servidor)
            me.$swal("Error al cargar el documento: " + (error.response.statusText || error.response.status));
          } else {
            // Errores de red o de otro tipo
            me.$swal("Error de red o conexión: " + error.message);
          }
        });
    },

    listar1() {
      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get("api/carpetas/listarcarpetas", configuracion)
        .then(function (response) {
          // Asumiendo que response.data.carpeta es un array de objetos
          // Cada objeto debería tener 'id', 'carpetanombre', y opcionalmente 'children' y 'file'
          me.carpetas = response.data.carpeta;
        })
        .catch(function (error) {
          console.error(error); // Usa console.error para los errores
          if (error.response && error.response.data && error.response.data.code == 400) {
            me.$swal("La Sesión ha Expirado");
            me.$store.dispatch("salir");
          } else {
            me.$swal("Error al cargar las carpetas: " + (error.response ? error.response.data.message : error.message));
          }
        });
    },

    listarporfecha() {
      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/documentos/listarporfecha/" + me.carpetaid + '/' + me.fecha1 + '/' + me.fecha2 + '/' + me.empresaid, configuracion)
        .then(function (response) {
          me.documentosporfecha = response.data.documento;
        })
        .catch(function (error) {
          console.error(error); // Usa console.error para los errores
          if (error.response && error.response.data && error.response.data.code == 400) {
            me.$swal("La Sesión ha Expirado");
            me.$store.dispatch("salir");
          } else {
            me.$swal("Error al cargar las carpetas: " + (error.response ? error.response.data.message : error.message));
          }
        });
    },

    listarporfechatodos() {
      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/documentos/listarporfechatodos/" + me.fecha1 + '/' + me.fecha2, configuracion)
        .then(function (response) {
          me.documentosporfecha = response.data.documento;
        })
        .catch(function (error) {
          console.error(error); // Usa console.error para los errores
          if (error.response && error.response.data && error.response.data.code == 400) {
            me.$swal("La Sesión ha Expirado");
            me.$store.dispatch("salir");
          } else {
            me.$swal("Error al cargar las carpetas: " + (error.response ? error.response.data.message : error.message));
          }
        });
    },

    selectgasolinatipo() {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/combustibles/listarcombustibles", configuracion)
        .then(function (response) {
          listaArray = response.data.combustible;
          listaArray.map(function (x) {
            me.combustiblecargaselect.push({
              text: x.combustiblenombre,
              value: x.combustibleid,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    guardardocumentocarpeta() {

      if (this.carpetaid == "") {
        this.$swal("No se a Especificado La Carpeta");
        return;
      }


      if (this.carpetadocumentonombre == "") {
        this.$swal("No se a Especificado Nombre del Documento");
        return;
      }

      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      let me = this;

       me.$swal({
        icon: "warning",
        title: "Estas Seguro de Guardar",
        html:
          "El Nombre de La DOCUMENTO es: " + me.carpetadocumentonombre,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
      }).then((result) => {
        if (result.value) {
          axios
            .post("api/carpetas/crear", {
              carpetanombre: me.carpetadocumentonombre,
              carpetapadre: me.carpetaid,
              carpetaodocumento: 2,
              tipodedocumento: me.tipocomprobanteid
            }, configuracion)
            .then(function (response) {
               me.listar1();
              me.TablaVisible = 0;
              me.dialog = false;
              me.$swal("Guardado", "Se a Guardado con Exito", "success");
            })
            .catch(function (error) {
              if (error.status === 401) {
                me.$swal("La Sesión a Expirado");
                me.$store.dispatch("salir");
              }
              if (error.name == "Error") {
                me.limpiar();
                me.listar();
                me.close();
                me.$swal("No se a Eliminado el Riego Checar");
              }
            });
        }
      });





    },

    guardar() {
      if (this.carpetadocumentonombre == "") {
        this.$swal("No se a Especificado Nombre de la Carpeta");
        return;
      }

      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      let me = this;
        me.$swal({
        icon: "warning",
        title: "Estas Seguro de Guardar",
        html:
          "El Nombre de La CARPETA es: " + me.carpetadocumentonombre,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
      }).then((result) => {
        if (result.value) {
          axios
            .post("api/carpetas/crear", {
              carpetanombre: me.carpetadocumentonombre,
              carpetapadre: me.carpetaid,
              carpetaodocumento: 1,
              tipodedocumento: me.tipocomprobanteid
            }, configuracion)
            .then(function (response) {
               me.listar1();
              me.TablaVisible = 0;
              me.dialog = false;
              me.$swal("Guardado", "Se a Guardado con Exito", "success");
            })
            .catch(function (error) {
              if (error.status === 401) {
                me.$swal("La Sesión a Expirado");
                me.$store.dispatch("salir");
              }
              if (error.name == "Error") {
                me.limpiar();
                me.listar();
                me.close();
                me.$swal("No se a Eliminado el Riego Checar");
              }
            });
        }
      });





      
        
    },

    guardarcarpetaodocumento() {


      if (this.tipodocumentoid == 1) {
        this.guardar();
      }

      if (this.tipodocumentoid == 2) {
        this.guardardocumentocarpeta();
      }

    },

    guardardocumentofisico() {
      if (this.carpetaodocumento == "") {
        this.$swal("No se a Especificado el Documento");
        return;
      }

      if (this.carpetaodocumento == 1) {
        this.$swal("No se puede Agregar un Documento porque es una Carpeta");
        return;
      }

      if (this.carpetaodocumento == 2) {
        this.modaldocumento = 1;
      }



    },

    handleFileUpload() {
      /*
          Set the local file variable to what the user has selected.
        */
      this.file = this.$refs.file.files[0];

      /*
          Initialize a File Reader object
        */
      let reader = new FileReader();

      /*
          Add an event listener to the reader that when the file
          has been loaded, we flag the show preview as true and set the
          image to be what was read from the reader.
        */
      reader.addEventListener(
        "load",
        function () {
          if (/\.(jpe?g|png|gif)$/i.test(this.file.name)) {
            this.imagenopdf = 1;
            this.extencion = 1;
            this.showPreview = true;
            this.imagePreview = reader.result;
          }

          if (/\.(pdf)$/i.test(this.file.name)) {
            this.imagenopdf = 2;
            this.extencion = 2;
            this.showPreview = true;
            this.pdfPreview = reader.result;
          }
        }.bind(this),
        false
      );



      /*
          Check to see if the file is not empty.
        */
      if (this.file) {
        /*
            Ensure the file is an image file.
          */
        if (/\.(jpe?g|png|gif)$/i.test(this.file.name)) {
          reader.readAsDataURL(this.file);
        }
        if (/\.(pdf)$/i.test(this.file.name)) {
          reader.readAsDataURL(this.file);
        }
      }
    },

    close() {
      this.modaldocumento = 0;
      this.limpiar();
    },

    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    handleFileChange(event) {
      this.error = null;
      const file = event.target.files[0];

      if (!file) {
        return;
      }

      if (file.type !== "text/xml" && !file.name.endsWith(".xml")) {
        this.error = "Por favor, selecciona un archivo XML válido (CFDI).";
        this.xmlData = null;
        this.parsedXml = null;
        return;
      }

      const reader = new FileReader();

      reader.onload = (e) => {
        try {
          this.xmlData = e.target.result;
          this.parseXml(this.xmlData);
        } catch (err) {
          this.error = "Error al leer o parsear el archivo CFDI: " + err.message;
          this.xmlData = null;
          this.parsedXml = null;
        }
      };

      reader.onerror = () => {
        this.error = "No se pudo leer el archivo.";
        this.xmlData = null;
        this.parsedXml = null;
      };

      reader.readAsText(file);
    },
    parseXml(xmlString) {
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(xmlString, "application/xml");

      // Verificar errores de parseo
      if (xmlDoc.getElementsByTagName("parsererror").length > 0) {
        this.error = "Error al parsear el CFDI. El archivo puede estar mal formado.";
        this.parsedXml = null;
        return;
      }

      // --- Extracción de datos del CFDI ---
      const comprobante = xmlDoc.getElementsByTagName('cfdi:Comprobante')[0];
      if (!comprobante) {
        this.error = "No se encontró la etiqueta 'cfdi:Comprobante' principal en el XML.";
        this.parsedXml = null;
        return;
      }

      const emisor = comprobante.getElementsByTagName('cfdi:Emisor')[0];
      const receptor = comprobante.getElementsByTagName('cfdi:Receptor')[0];
      const concepto = comprobante.getElementsByTagName('cfdi:Concepto')[0]; // Tomamos el primer concepto

      const parsedData = {
        // Datos del Comprobante
        comprobante: {
          version: comprobante.getAttribute('Version'),
          fecha: comprobante.getAttribute('Fecha'),
          folio: comprobante.getAttribute('Folio'), // <--- Agregado: Extrae el atributo Folio
          total: comprobante.getAttribute('Total'),
          subTotal: comprobante.getAttribute('SubTotal'),
          moneda: comprobante.getAttribute('Moneda'),
          tipoDeComprobante: comprobante.getAttribute('TipoDeComprobante'), // <-- Ya estaba, se asegura
          lugarExpedicion: comprobante.getAttribute('LugarExpedicion'),
          formaPago: comprobante.getAttribute('FormaPago'),
          metodoPago: comprobante.getAttribute('MetodoPago'),
          condicionesDePago: comprobante.getAttribute('CondicionesDePago'),
          exportacion: comprobante.getAttribute('Exportacion'),
        },
        // Datos del Emisor
        emisor: emisor ? {
          rfc: emisor.getAttribute('Rfc'),
          nombre: emisor.getAttribute('Nombre'),
          regimenFiscal: emisor.getAttribute('RegimenFiscal'),
        } : null,
        // Datos del Receptor
        receptor: receptor ? {
          rfc: receptor.getAttribute('Rfc'),
          nombre: receptor.getAttribute('Nombre'),
          domicilioFiscalReceptor: receptor.getAttribute('DomicilioFiscalReceptor'),
          regimenFiscalReceptor: receptor.getAttribute('RegimenFiscalReceptor'),
          usoCFDI: receptor.getAttribute('UsoCFDI'),
        } : null,
        // Datos del Primer Concepto
        concepto: concepto ? {
          claveProdServ: concepto.getAttribute('ClaveProdServ'),
          noIdentificacion: concepto.getAttribute('NoIdentificacion'),
          cantidad: concepto.getAttribute('Cantidad'),
          unidad: concepto.getAttribute('Unidad'),
          descripcion: concepto.getAttribute('Descripcion'),
          valorUnitario: concepto.getAttribute('ValorUnitario'),
          importe: concepto.getAttribute('Importe'),
          objetoImp: concepto.getAttribute('ObjetoImp'),
          impuestosConcepto: (() => {
            const trasladoConcepto = concepto.getElementsByTagName('cfdi:Traslado')[0];
            return trasladoConcepto ? {
              base: trasladoConcepto.getAttribute('Base'),
              impuesto: trasladoConcepto.getAttribute('Impuesto'),
              tipoFactor: trasladoConcepto.getAttribute('TipoFactor'),
              tasaOCuota: trasladoConcepto.getAttribute('TasaOCuota'),
              importe: trasladoConcepto.getAttribute('Importe'),
            } : null;
          })(),
        } : null,
        // Datos de Impuestos Globales (Totales)
        impuestosGlobales: (() => {
          const impuestos = xmlDoc.getElementsByTagName('cfdi:Impuestos')[0];
          const trasladoGlobal = impuestos ? impuestos.getElementsByTagName('cfdi:Traslado')[0] : null;
          return trasladoGlobal ? {
            totalImpuestosTrasladados: impuestos.getAttribute('TotalImpuestosTrasladados'),
            base: trasladoGlobal.getAttribute('Base'),
            impuesto: trasladoGlobal.getAttribute('Impuesto'),
            tipoFactor: trasladoGlobal.getAttribute('TipoFactor'),
            tasaOCuota: trasladoGlobal.getAttribute('TasaOCuota'),
            importe: trasladoGlobal.getAttribute('Importe'),
          } : null;
        })(),
        // Datos del Timbre Fiscal Digital
        timbreFiscalDigital: (() => {
          const timbre = xmlDoc.getElementsByTagName('tfd:TimbreFiscalDigital')[0];
          if (!timbre) {
            const complementos = xmlDoc.getElementsByTagName('cfdi:Complemento');
            if (complementos.length > 0) {
              const children = Array.from(complementos[0].children);
              for (const child of children) {
                if (child.localName === 'TimbreFiscalDigital') {
                  return {
                    uuid: child.getAttribute('UUID'),
                    fechaTimbrado: child.getAttribute('FechaTimbrado'),
                    noCertificadoSAT: child.getAttribute('NoCertificadoSAT'),
                    selloCFD: child.getAttribute('SelloCFD'),
                    selloSAT: child.getAttribute('SelloSAT'),
                    version: child.getAttribute('Version'),
                    rfcProvCertif: child.getAttribute('RfcProvCertif'),
                  };
                }
              }
            }
            return null;
          }
          return {
            uuid: timbre.getAttribute('UUID'),
            fechaTimbrado: timbre.getAttribute('FechaTimbrado'),
            noCertificadoSAT: timbre.getAttribute('NoCertificadoSAT'),
            selloCFD: timbre.getAttribute('SelloCFD'),
            selloSAT: timbre.getAttribute('SelloSAT'),
            version: timbre.getAttribute('Version'),
            rfcProvCertif: timbre.getAttribute('RfcProvCertif'),
          };
        })(),
      };

      this.parsedXml = parsedData;
      this.documentofolio = this.parsedXml.comprobante.folio
      this.documentocombustible = this.parsedXml.concepto.descripcion
      this.documentolitros = this.parsedXml.concepto.cantidad
      this.documentofechacarga = moment(this.parsedXml.comprobante.fecha).format('YYYY-MM-DD')
      this.documentoprecio = this.parsedXml.concepto.valorUnitario
      this.documentosubtotal = this.parsedXml.concepto.importe
      this.documentoiva = this.parsedXml.concepto.impuestosConcepto.importe
      this.documentototal = this.parsedXml.comprobante.total
      this.combustibleid = this.parsedXml.concepto.claveProdServ
      this.documentouiid = this.parsedXml.timbreFiscalDigital.uuid
    },

    limpiar() {
      this.documentoiva = "";
      this.documentosubtotal = "";
      this.documentoprecio = "";
      this.combustibleid = "";
      this.documentocartaporte = "";
      this.documentouiid = "";
      this.combustiblecargaid = "";
      this.documentoobservacion = "";
      this.carpetadocumentonombre = "";
      this.carpetaodocumento = "";
      this.documentofolio = "";
      this.documentofechacarga = moment(new Date(), "DD/MM/YYYY").format("YYYY-MM-DD");
      this.documentofechavence = moment(new Date(), "DD/MM/YYYY").format("YYYY-MM-DD");
      this.file = null;
      this.imagePreview = null;
      this.magenopdf = null;
      this.imagenopdf = 0;
      this.$refs.file.value = null;
      this.$refs.fileInput.value = null;
      this.documentototal= "";
      this.documentolitros= "";
      this.documentocombustible="";

      
    },

    selectecombustiblenombre() {
      this.documentocombustible = event.target.textContent;
    },

    guardardocumento() {

      if (this.tipocomprobanteid == 1) {

        if (this.documentofolio == "") {
          this.$swal("No se a Especificado el Numero de Factura");
          return;
        }

        if (this.documentocombustible == "") {
          this.$swal("No se a Especificado el Nombre del Combustible");
          return;
        }

        if (this.documentolitros == "") {
          this.$swal("No se a Especificado los Litros");
          return;
        }

        if (this.documentoprecio == "") {
          this.$swal("No se a Especificado el Precio");
          return;
        }

        if (this.documentosubtotal == "") {
          this.$swal("No se a Especificado el Sub Total");
          return;
        }

        if (this.documentoiva == "") {
          this.$swal("No se a Especificado el Sub Total");
          return;
        }

        if (this.documentototal == "") {
          this.$swal("No se a Especificado el Total");
          return;
        }

        if (this.documentouiid == "") {
          this.$swal("No se a Especificado el UUID");
          return;
        }

        if (this.file == null) {
          this.$swal("No se a Ingresado la Factura");
          return;
        }


      }

      if (this.tipocomprobanteid == 2) {

        if (this.documentofolio == "") {
          this.$swal("No se a Especificado el Numero de Factura");
          return;
        }

        if (this.documentocartaporte == "") {
          this.$swal("No se a Especificado el El Numero de Carta Porte");
          return;
        }

        if (this.combustiblecargaid == "") {
          this.$swal("No se a Especificado el Tipo de Combustible");
          return;
        }

        if (this.file == null) {
          this.$swal("No se a Ingresado la Carta Porte");
          return;
        }


      }

      if (this.tipocomprobanteid == 4) {

        if (this.documentofolio == "") {
          this.$swal("No se a Especificado el Numero de Folio");
          return;
        }

        if (this.file == null) {
          this.$swal("No se a Ingresado el Documento");
          return;
        }

      }

      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };

      let formData = new FormData();
      
      formData.append("documentonombre", me.documentonombre);
      formData.append("empresaid", me.empresaid);
      formData.append("empresanombre", me.empresanombre);
      formData.append("carpetaid", me.carpetaid);
      formData.append("carpetanombre", me.carpetanombre);
      formData.append("documentoruta", me.fullPath);
      formData.append("documentoobservacion", me.documentoobservacion);
      formData.append("usuarioid", me.$store.state.usuario.usuarioid);
      formData.append("file0", me.file);
      formData.append("documentoextencion", me.imagenopdf);
      formData.append("documentocombustible", me.documentocombustible);
      formData.append("documentofecha", me.documentofechacarga);
      formData.append("documentofolio", me.documentofolio);
      formData.append("documentotipo", me.tipocomprobanteid);
      formData.append("documentototal", me.documentototal);
      formData.append("documentolitros", me.documentolitros);
      formData.append("documentoiva", me.documentoiva);
      formData.append("documentosubtotal", me.documentosubtotal);
      formData.append("documentoprecio", me.documentoprecio);
      formData.append("combustibleid", me.combustibleid);
      formData.append("documentocartaporte", me.documentocartaporte);
      formData.append("documentouiid", me.documentouiid);
      formData.append("documentofechavencimiento", me.documentofechavence);


      me.$swal({
        icon: "warning",
        title: "Estas Seguro de Guardar",
        html:
          "La Fecha es: " + me.documentofechacarga+"<br>"
          +me.documentonombre,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
      }).then((result) => {
        if (result.value) {
          axios
            .post("api/documentos/crear", formData, configuracion)
            .then(function (response) {
              me.close();
              me.listar1();
              me.limpiar();
              me.$swal("Guardado", "Se a Guardado con Exito", "success");
              me.close();
            })
            .catch(function (error) {
              if (error.status === 401) {
                me.$swal("La Sesión a Expirado");
                me.$store.dispatch("salir");
              }
              if (error.name == "Error") {
                me.limpiar();
                me.listar();
                me.close();
                me.$swal("No se a Eliminado el Riego Checar");
              }
            });
        }
      });






    },


    deleteFile(item) {
      this.carpetaid = item.carpetaid;
      this.fullPath = this.getFolderPath(item); // Ruta completa hasta la carpeta padre
      this.carpetanombre = item.carpetanombre; // Nombre de la carpeta a eliminar

      // La ruta completa de la carpeta que se va a eliminar
      const rutaAEliminar = this.fullPath + "/" + this.carpetanombre;

      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };

      me.$swal({
        icon: "warning", // Cambiado a 'warning' para una acción de eliminación
        title: "¿Estás seguro?",
        text: `¡Esta acción eliminará la Documento "${this.carpetanombre}" y todo su contenido de forma permanente! ¿Deseas continuar?`,
        showCancelButton: true,
        confirmButtonColor: "#d33", // Rojo para la acción de eliminar
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) { // Si el usuario confirma la eliminación
          axios
            .delete(
              `api/carpetas/eliminardocumento/${me.carpetaid}`,
              {
                data: { // Para enviar datos en una solicitud DELETE con Axios, usa la propiedad 'data'
                  ruta_carpeta_fisica: rutaAEliminar,
                  empresaid: me.empresaid
                }
              },
              configuracion
            )
            .then(function (response) {
              me.$swal("¡Eliminado!", "La carpeta ha sido eliminada con éxito.", "success");
              me.limpiar(); // Refresca el estado o la vista
              me.listar1(); // Refresca la lista de carpetas
            })
            .catch(function (error) {
              if (error.response && error.response.status === 401) {
                me.$swal("La sesión ha expirado", "Por favor, inicia sesión de nuevo.", "error");
                me.$store.dispatch("salir");
              } else {
                console.error("Error al eliminar carpeta:", error);
                let errorMessage = "No se pudo eliminar la carpeta. Por favor, inténtalo de nuevo.";
                if (error.response && error.response.data && error.response.data.message) {
                  errorMessage = error.response.data.message; // Mostrar mensaje de error del backend si existe
                }
                me.$swal("Error", errorMessage, "error");
              }
              me.limpiar();
              me.listar1();
            });
        }
      });
    },


    deleteItem(item) {
      this.carpetaid = item.carpetaid;
      this.fullPath = this.getFolderPath(item); // Ruta completa hasta la carpeta padre
      this.carpetanombre = item.carpetanombre; // Nombre de la carpeta a eliminar

      // La ruta completa de la carpeta que se va a eliminar
      const rutaAEliminar = this.fullPath + "/" + this.carpetanombre;

      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };

      me.$swal({
        icon: "warning", // Cambiado a 'warning' para una acción de eliminación
        title: "¿Estás seguro?",
        text: `¡Esta acción eliminará la carpeta "${this.carpetanombre}" y todo su contenido de forma permanente! ¿Deseas continuar?`,
        showCancelButton: true,
        confirmButtonColor: "#d33", // Rojo para la acción de eliminar
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) { // Si el usuario confirma la eliminación
          axios
            .delete(
              "api/carpetas/eliminarcarpeta/"+me.carpetaid,{
               },
              configuracion
            )
            .then(function (response) {
              me.$swal("¡Eliminado!", "La carpeta ha sido eliminada con éxito.", "success");
              me.listar1(); // Refresca la lista de carpetas
            })
            .catch(function (error) {
              if (error.response && error.response.status === 401) {
                me.$swal("La sesión ha expirado", "Por favor, inicia sesión de nuevo.", "error");
                me.$store.dispatch("salir");
              } else {
                console.error("Error al eliminar carpeta:", error);
                let errorMessage = "No se pudo eliminar la carpeta. Por favor, inténtalo de nuevo.";
                if (error.response && error.response.data && error.response.data.message) {
                  errorMessage = error.response.data.message; // Mostrar mensaje de error del backend si existe
                }
                me.$swal("Error", errorMessage, "error");
              }
              me.limpiar();
              me.listar1();
            });
        }
      });
    },

    editItem(item) {

      this.carpetaid = item.carpetaid; // Asumo que el ID de la carpeta se llama 'id'
      this.fullPath = this.getFolderPath(item); // Aquí calculas la ruta completa
      this.carpetanombre = item.carpetanombre;


      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };

      me.$swal({
        icon: "question", // Cambiado a 'question' o 'info' para una edición
        title: "Editar Nombre de Carpeta",
        input: "text", // <--- Esto agrega un campo de texto
        inputLabel: "Nuevo nombre de la carpeta:", // <--- Etiqueta para el campo de texto
        inputValue: item.carpetanombre, // <--- Valor inicial del campo de texto (nombre actual)
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar Cambios",
        cancelButtonText: "Cancelar", // Texto para el botón de cancelar
        inputValidator: (value) => {
          // Validador: asegura que el campo no esté vacío
          if (!value) {
            return "¡Necesitas escribir un nombre para la carpeta!";
          }
          if (value.trim() === '') { // También verifica si solo son espacios en blanco
            return "¡El nombre de la carpeta no puede estar vacío!";
          }
          return null; // Retorna null si la validación es exitosa
        }
      }).then((result) => {
        if (result.isConfirmed) { // Usa result.isConfirmed para el botón de confirmar
          const nuevoNombre = result.value; // <--- El valor ingresado por el usuario

          axios
            .put(
              // La URL debe apuntar al endpoint de edición y al ID de la carpeta
              // y el cuerpo de la solicitud debe enviar el nuevo nombre.
              `api/carpetas/editarnombrecarpeta/${me.carpetaid}`,
              {
                carpetanombre: nuevoNombre,
                carpetanombredireccionvieja: me.fullPath + "/" + me.carpetanombre,
                carpetanombredireccionnueva: me.fullPath + "/" + nuevoNombre,
                empresaid: me.empresaid

              }, // <--- Envía el nuevo nombre en el cuerpo de la solicitud
              configuracion
            )
            .then(function (response) {
              me.$swal("¡Actualizado!", "El nombre de la carpeta ha sido modificado con éxito.", "success");
              me.limpiar(); // Si estas funciones refrescan el estado o la vista
              me.listar1(); // Si estas funciones refrescan el estado o la vista
              // me.close(); // Esta función podría ser para cerrar un modal si existiera
            })
            .catch(function (error) {
              // Si el error tiene una propiedad 'response.status', úsala
              if (error.response && error.response.status === 401) {
                me.$swal("La sesión ha expirado", "Por favor, inicia sesión de nuevo.", "error");
                me.$store.dispatch("salir");
              } else {
                // Manejo de otros errores
                console.error("Error al editar carpeta:", error);
                me.$swal("Error", "No se pudo actualizar el nombre de la carpeta. Por favor, inténtalo de nuevo.", "error");
              }
              me.limpiar(); // Aunque haya error, podrías querer refrescar por si acaso
              me.listar1();
              // me.close();
            });
        }
      });
    },

    editFile(item) {

      this.carpetaid = item.carpetaid; // Asumo que el ID de la carpeta se llama 'id'
      this.fullPath = this.getFolderPath(item); // Aquí calculas la ruta completa
      this.carpetanombre = item.carpetanombre;


      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };

      me.$swal({
        icon: "question", // Cambiado a 'question' o 'info' para una edición
        title: "Editar Nombre de Carpeta",
        input: "text", // <--- Esto agrega un campo de texto
        inputLabel: "Nuevo nombre del Documento:", // <--- Etiqueta para el campo de texto
        inputValue: item.carpetanombre, // <--- Valor inicial del campo de texto (nombre actual)
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar Cambios",
        cancelButtonText: "Cancelar", // Texto para el botón de cancelar
        inputValidator: (value) => {
          // Validador: asegura que el campo no esté vacío
          if (!value) {
            return "¡Necesitas escribir un nombre para la carpeta!";
          }
          if (value.trim() === '') { // También verifica si solo son espacios en blanco
            return "¡El nombre de la carpeta no puede estar vacío!";
          }
          return null; // Retorna null si la validación es exitosa
        }
      }).then((result) => {
        if (result.isConfirmed) { // Usa result.isConfirmed para el botón de confirmar
          const nuevoNombre = result.value; // <--- El valor ingresado por el usuario

          axios
            .put(
              // La URL debe apuntar al endpoint de edición y al ID de la carpeta
              // y el cuerpo de la solicitud debe enviar el nuevo nombre.
              `api/carpetas/editarnombredocumento/${me.carpetaid}`,
              {
                carpetanombre: nuevoNombre,
              }, // <--- Envía el nuevo nombre en el cuerpo de la solicitud
              configuracion
            )
            .then(function (response) {
              me.$swal("¡Actualizado!", "El nombre de la carpeta ha sido modificado con éxito.", "success");
              me.limpiar(); // Si estas funciones refrescan el estado o la vista
              me.listar1(); // Si estas funciones refrescan el estado o la vista
              // me.close(); // Esta función podría ser para cerrar un modal si existiera
            })
            .catch(function (error) {
              // Si el error tiene una propiedad 'response.status', úsala
              if (error.response && error.response.status === 401) {
                me.$swal("La sesión ha expirado", "Por favor, inicia sesión de nuevo.", "error");
                me.$store.dispatch("salir");
              } else {
                // Manejo de otros errores
                console.error("Error al editar carpeta:", error);
                me.$swal("Error", "No se pudo actualizar el nombre de la carpeta. Por favor, inténtalo de nuevo.", "error");
              }
              me.limpiar(); // Aunque haya error, podrías querer refrescar por si acaso
              me.listar1();
              // me.close();
            });
        }
      });
    },




  },
};
</script>

<style>
.tree-node {
  display: flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.tree-node:hover {
  background-color: #f1f1f1;
}

.selected-node {
  background-color: #ebeff3;
  /* Azul claro */
  font-weight: bold;
  color: #000000;
}
</style>
